/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Financial/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconPaid from 'DesignSystem/Svgs/TysiaIconPaid/index'



/** @type {import('Simple/types.js').View} */
export default function Financial({
  children,
  viewPath = "/App/Account/Topbar/Tabs/More/Content/Tabs/Tab/Icon/Financial",
  hovered,
  selected
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsGreen600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.600'
        })
  return (<React.Fragment
>
<TysiaIconPaid
  viewPath={`${viewPath}/TysiaIconPaid`}
 width={16}
 height={16}
 fill={hovered && selected ? dtColorsGreen600 : hovered ? dtColorsWhite : selected ? dtColorsGreen600 : dtColorsWhite}
/>
{children}
</React.Fragment>)
}